import { Link, useNavigate } from "react-router-dom";
import { BookOpen, LogOut, Upload, FileText, Search, Bookmark, Gift, CreditCard, Sparkles, Tag } from "lucide-react";
import { Button } from "@/components/ui/button";
import Logo from "./Logo";
import InboxBell from "./InboxBell";
import UserAvatar from "./UserAvatar";

const Navigation = ({ user, setUser }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    if (setUser) setUser(null);
    navigate('/');
  };

  return (
    <nav className="bg-white/80 backdrop-blur-md border-b border-slate-200/50 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap lg:flex-nowrap justify-between items-center min-h-16 gap-y-2 py-2">
          <Link to="/" data-testid="nav-logo" className="shrink-0">
            <Logo />
          </Link>
          <div className="flex w-full lg:w-auto min-w-0 items-center gap-1 flex-wrap justify-start lg:justify-end">
            {user ? (
              <>
                <Button
                  onClick={() => navigate('/')}
                  variant="ghost"
                  size="sm"
                  data-testid="nav-home-btn"
                >
                  Home
                </Button>
                <Button
                  onClick={() => navigate('/smart-search')}
                  variant="ghost"
                  size="sm"
                  data-testid="nav-smart-search-btn"
                >
                  <Search className="w-4 h-4 mr-1" />
                  Smart Search
                </Button>
                <Button
                  onClick={() => navigate('/research')}
                  variant="ghost"
                  size="sm"
                  data-testid="nav-ai-researcher-btn"
                >
                  <Sparkles className="w-4 h-4 mr-1" />
                  AI Researcher
                </Button>
                <Button
                  onClick={() => navigate('/topics')}
                  variant="ghost"
                  size="sm"
                  data-testid="nav-topics-btn"
                >
                  <Tag className="w-4 h-4 mr-1" />
                  Topics
                </Button>
                <Button
                  onClick={() => navigate('/collections')}
                  variant="ghost"
                  size="sm"
                  data-testid="nav-collections-btn"
                >
                  <Bookmark className="w-4 h-4 mr-1" />
                  Collections
                </Button>
                <Button
                  onClick={() => navigate('/referral')}
                  variant="ghost"
                  size="sm"
                  data-testid="nav-referral-btn"
                >
                  <Gift className="w-4 h-4 mr-1" />
                  Refer & Earn
                </Button>
                <Button
                  onClick={() => navigate('/upload')}
                  variant="ghost"
                  size="sm"
                  data-testid="nav-upload-btn"
                >
                  <Upload className="w-4 h-4 mr-1" />
                  Submit
                </Button>
                <Button
                  onClick={() => navigate('/subscriptions')}
                  variant="ghost"
                  size="sm"
                  data-testid="nav-pricing-btn"
                >
                  <CreditCard className="w-4 h-4 mr-1" />
                  Pricing
                </Button>
                <Button
                  onClick={() => navigate('/my-submissions')}
                  variant="ghost"
                  size="sm"
                  data-testid="nav-submissions-btn"
                >
                  <FileText className="w-4 h-4 mr-1" />
                  My Submissions
                </Button>
                {user.role === 'admin' && (
                  <Button
                    onClick={() => navigate('/admin')}
                    variant="ghost"
                    size="sm"
                    data-testid="nav-dashboard-btn"
                  >
                    Dashboard
                  </Button>
                )}
                <Button
                  onClick={() => navigate('/profile')}
                  variant="ghost"
                  size="sm"
                  data-testid="nav-profile-btn"
                  title="My Profile"
                >
                  <UserAvatar user={user} size={22} className="mr-1.5" />
                  {user.name || user.email}
                </Button>
                <InboxBell />
                <Button
                  onClick={handleLogout}
                  variant="ghost"
                  size="sm"
                  data-testid="nav-logout-btn"
                >
                  <LogOut className="w-4 h-4" />
                </Button>
              </>
            ) : (
              <>
                <Button
                  onClick={() => navigate('/search')}
                  variant="ghost"
                  size="sm"
                >
                  Home
                </Button>
                <Button
                  onClick={() => navigate('/smart-search')}
                  variant="ghost"
                  size="sm"
                  data-testid="nav-smart-search-public"
                >
                  <Search className="w-4 h-4 mr-1" />
                  Smart Search
                </Button>
                <Button
                  onClick={() => navigate('/topics')}
                  variant="ghost"
                  size="sm"
                  data-testid="nav-topics-public"
                >
                  <Tag className="w-4 h-4 mr-1" />
                  Topics
                </Button>
                <Button
                  onClick={() => navigate('/upload')}
                  variant="ghost"
                  size="sm"
                >
                  <Upload className="w-4 h-4 mr-1" />
                  Submit Document
                </Button>
                <Button
                  onClick={() => navigate('/subscriptions')}
                  variant="ghost"
                  size="sm"
                  data-testid="nav-pricing-public"
                >
                  <CreditCard className="w-4 h-4 mr-1" />
                  Pricing
                </Button>
                <Button
                  onClick={() => navigate('/login')}
                  className="bg-slate-900 text-white hover:bg-slate-800"
                  data-testid="nav-login-btn"
                >
                  Login
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;